import "../../styles/UserDashboard/withdrawalModal.scss";

export default function WithdrawalModal({open, setOpen}) {
    return (
        open &&
        <div className="withdrawal-modal">
        <div className="withdrawal-modal__inner">
            <div className="withdrawal-modal__inner__title">
            Input Amount
            </div>
            <div className="withdrawal-modal__inner__input">
                <div>₦</div>
                <input type="number" />
                </div>
           <div className="withdrawal-modal__inner__group">
            <div>Balance:</div>
            <div>₦15,290.25</div>
           </div>
            <button
            onClick={() => setOpen(false)}
            >Withdraw</button>
        </div>
        </div>
    );
}